export interface RowSlot {
  top: number;
  height: number;
}

export function moveKeyToIndex(
  keys: readonly string[],
  key: string,
  index: number,
): string[] {
  const next = [...keys],
    from = next.indexOf(key);
  if (from < 0 || !Number.isFinite(index)) return next;
  const to = Math.max(0, Math.min(next.length - 1, Math.round(index)));
  next.splice(from, 1);
  next.splice(to, 0, key);
  return next;
}

export function nearestRow(slots: readonly RowSlot[], center: number): number {
  let best = 0,
    distance = Infinity;
  slots.forEach((slot, index) => {
    const delta = Math.abs(slot.top + slot.height / 2 - center);
    if (delta < distance) {
      best = index;
      distance = delta;
    }
  });
  return best;
}

export function previewOffsets(
  slots: readonly RowSlot[],
  from: number,
  to: number,
): number[] {
  if (!slots[from] || !slots[to]) return slots.map(() => 0);
  const gap =
    slots.length > 1 ? slots[1].top - slots[0].top - slots[0].height : 0;
  const shift = slots[from].height + gap;
  return slots.map((slot, index) => {
    if (index === from)
      return (
        (to > from
          ? slots[to].top + slots[to].height - slot.height
          : slots[to].top) - slot.top
      );
    if (from < to && index > from && index <= to) return -shift;
    if (from > to && index >= to && index < from) return shift;
    return 0;
  });
}

/** Pixels/second, with a gradual ramp near either edge; zero outside scroll bounds. */
export function edgeScrollSpeed(
  pointerY: number,
  top: number,
  bottom: number,
): number {
  const band = Math.min(64, (bottom - top) / 3);
  if (band <= 0) return 0;
  if (pointerY < top + band)
    return -480 * Math.min(1, Math.max(0, (top + band - pointerY) / band));
  if (pointerY > bottom - band)
    return 480 * Math.min(1, Math.max(0, (pointerY - bottom + band) / band));
  return 0;
}
